import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  titles: {
    width: '60px',
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: 600,
    marginLeft: '7px',
  },
  tagName: {
    background: 'transparent !important',
    fontSize: '14px',
    color: '#ffffffdd',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as any,
  },
});
